(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["free-shipping-info"] && !Shopify.designMode) return;
  try {
    if (!window.__freeShippingInfoDefined) {
    window.__freeShippingInfoDefined = true;

    // Sepete ekle / değiştir / güncelle isteklerini dinle (tema ayrıca olay yayınlamıyor).
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const input = args[0];
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const result = originalFetch.apply(this, args);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        result
          .then(() => document.dispatchEvent(new CustomEvent('free-shipping:cart-changed')))
          .catch(() => {});
      }
      return result;
    };

    class FreeShippingInfo extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.dataset.threshold) || 150000;
        this.nutIds = (this.dataset.nutIds || '').split(',').filter(Boolean);
        this.productIsNut = this.dataset.productIsNut === 'true';
        this.productPrice = Number(this.dataset.productPrice) || 0;
        this.moneyFormat = this.dataset.format || '{{amount}}TL';

        this.onCartChanged = () => this.refresh();
        document.addEventListener('free-shipping:cart-changed', this.onCartChanged);
        window.addEventListener('pageshow', this.onCartChanged);
        this.refresh();
      }

      disconnectedCallback() {
        document.removeEventListener('free-shipping:cart-changed', this.onCartChanged);
        window.removeEventListener('pageshow', this.onCartChanged);
      }

      formatMoney(cents) {
        const value = Math.max(0, cents) / 100;
        const withSep = (n, thousands, decimal, digits) => {
          const [whole, frac] = n.toFixed(digits).split('.');
          const w = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return frac ? w + decimal + frac : w;
        };
        return this.moneyFormat
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withSep(value, '.', ',', 0))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withSep(value, '.', ',', 2))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withSep(value, ',', '.', 0))
          .replace(/\{\{\s*amount\s*\}\}/, withSep(value, ',', '.', 2));
      }

      async refresh() {
        try {
          const response = await fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          this.render(cart);
        } catch (error) {
          /* bilgi amaçlı; sessizce geç */
        }
      }

      render(cart) {
        const subtotal = cart.items_subtotal_price || 0;
        const hasNut = (cart.items || []).some((item) => this.nutIds.includes(String(item.product_id)));
        const remaining = this.threshold - subtotal;
        const unlocked = hasNut || remaining <= 0;
        const percent = unlocked ? 100 : Math.min(100, Math.round((subtotal * 100) / this.threshold));

        const text = this.querySelector('[data-fsi-text]');
        const bar = this.querySelector('[data-fsi-bar]');
        const hint = this.querySelector('[data-fsi-hint]');

        this.classList.toggle('is-unlocked', unlocked);
        if (bar) bar.style.width = percent + '%';

        if (unlocked) {
          if (text) text.innerHTML = '<strong>\u{1F69A} Sepetinde kargo ücretsiz!</strong>';
          if (hint) hint.textContent = '';
          return;
        }

        if (text) {
          text.innerHTML = '<strong>\u{1F69A} Ücretsiz kargoya ' + this.formatMoney(remaining) + ' kaldı</strong>';
        }
        if (hint) {
          hint.textContent =
            this.productIsNut || this.productPrice >= remaining
              ? 'Bu ürünü eklersen kargo ücretsiz olur.'
              : 'Fındık ezmesi eklersen tutardan bağımsız ücretsiz.';
        }
      }
    }

    if (!customElements.get('free-shipping-info')) {
      customElements.define('free-shipping-info', FreeShippingInfo);
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["preorder-note"] && !Shopify.designMode) return;
  try {
    /* Rozeti, ürün görsel galerisinin (media-gallery) içine taşır. */
  if (!customElements.get('kuruca-preorder-badges')) {
    class KurucaPreorderBadges extends HTMLElement {
      connectedCallback() {
        this.place();
        this.observer = new MutationObserver(() => this.place());
        this.observer.observe(document.body, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      place() {
        const gallery = document.querySelector('media-gallery');
        const template = this.querySelector('template');
        if (!gallery || !template || gallery.querySelector(':scope > .kuruca-badges')) return;
        gallery.prepend(template.content.cloneNode(true));
      }
    }

    customElements.define('kuruca-preorder-badges', KurucaPreorderBadges);
  }
  } catch(e) { console.error(e); }
})();

})();
